const extractData =
  endpoint =>
  async (...args) => {
    const response = await endpoint(...args);
    return response.data;
  };

export default extractData;
